import { render } from "./TagManageOptions.vue?vue&type=template&id=7156069a&scoped=true"
import script from "./TagManageOptions.vue?vue&type=script&lang=js"
export * from "./TagManageOptions.vue?vue&type=script&lang=js"

import "./TagManageOptions.vue?vue&type=style&index=0&id=7156069a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7156069a"]])

export default __exports__